import MetricsTable from "@/metrics/MetricsTable";
import React from "react";
import { Header } from "@/components/header";

const EngineeringMetrics = () => {
  return (
    <>
      <Header
        name="Engineering metrics"
        showDatePicker={true}
        className="font-normal text-4xl"
      />
      <MetricsTable/>
    </>
  )
}

export default EngineeringMetrics;
